<template>
  <Modal v-model="productReviewForSaleLogModal" :title="$t('key1000288')" width="1000" :transfer="false"
    :mask-closable="false" :styles="{top: '60px'}" @on-visible-change="productReviewForSaleLogChange">
    <div class="log_modal_content">
      <div class="log_collapse_box">
        <Spin fix v-if="tableLoading"></Spin>
        <Collapse v-model="collapseValue">
          <Panel v-for="(item, index) in logList" :key="getPanelName(item, index)" :name="getPanelName(item, index)">
            <div class="log_panel_header" @click.stop>
              <span class="log_panel_user">{{ $t('key1003158') }}{{ getOperatorName(item) }}</span>
              <span class="log_panel_time">{{ $t('key1000770') }}{{ formatLogTime(item.updatedTime) }}</span>
            </div>
            <template #content>
              <div class="log_panel_content">
                <template v-if="item.logFormatSuccess && item.formattedLogItems.length">
                  <div class="log_compare_box">
                    <div class="log_compare_cols">
                      <div class="log_compare_col log_compare_old">
                        <p class="log_compare_title">{{ $t('key1000302') }}</p>
                        <div
                          v-for="(row, rowIndex) in item.formattedLogItems"
                          :key="'old_' + rowIndex"
                          class="log_compare_field">
                          <span class="field_label">{{ row.label }}：</span>
                          <div
                            v-if="row.valueType === 'imageList'"
                            class="field_value log_image_list"
                            v-viewer="viewerConfig">
                            <template v-if="row.oldImages && row.oldImages.length">
                              <img
                                v-for="(path, imgIndex) in row.oldImages"
                                :key="'old_img_' + rowIndex + '_' + imgIndex"
                                class="log_image_item"
                                :src="getLogCarouselThumbUrl(path)"
                                :data-original="getLogCarouselOriginalUrl(path)"
                                @error="setErrorImg($event)"
                                alt=""
                              />
                            </template>
                            <span v-else>-</span>
                          </div>
                          <span v-else class="field_value">{{ row.oldValue || '-' }}</span>
                        </div>
                      </div>
                      <div class="log_compare_divider"></div>
                      <div class="log_compare_col log_compare_new">
                        <p class="log_compare_title">{{ $t('key1003288') }}</p>
                        <div
                          v-for="(row, rowIndex) in item.formattedLogItems"
                          :key="'new_' + rowIndex"
                          class="log_compare_field">
                          <span class="field_label">{{ row.label }}：</span>
                          <div
                            v-if="row.valueType === 'imageList'"
                            class="field_value log_image_list"
                            v-viewer="viewerConfig">
                            <template v-if="row.newImages && row.newImages.length">
                              <img
                                v-for="(path, imgIndex) in row.newImages"
                                :key="'new_img_' + rowIndex + '_' + imgIndex"
                                class="log_image_item"
                                :src="getLogCarouselThumbUrl(path)"
                                :data-original="getLogCarouselOriginalUrl(path)"
                                @error="setErrorImg($event)"
                                alt=""
                              />
                            </template>
                            <span v-else>-</span>
                          </div>
                          <span v-else class="field_value">{{ row.newValue || '-' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <span v-else>{{ item.operateContent || $t('key1003287') }}</span>
              </div>
            </template>
          </Panel>
        </Collapse>
        <div v-if="!tableLoading && logList.length === 0" class="empty_tip">{{ $t('key1003289') }}</div>
      </div>
      <Page
        class="log_page_box"
        :transfer="true"
        v-if="!tableLoading && total > 0"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="curPage"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>

    <template #footer>
      <Button type="primary" @click="productReviewForSaleLogModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllUsersInfo, getFullImagePath, isJSON} from "@/utils/common";
import {formatProductDetailsLog} from '@/utils/productDetailsLogHandler';

export default {
  name: 'productReviewForSaleLogModal',
  mixins: [Mixin],
  data() {
    return {
      productReviewForSaleLogModal: false,
      productId: null,
      pageParams: {
        pageNum: 1,
        pageSize: 15
      },
      pageParamsStatus: false,
      logList: [],
      collapseValue: [],
      total: 0,
      curPage: 1,
      userInfoList: {}
    };
  },
  computed: {
    // 日志轮播图点击放大预览配置
    viewerConfig() {
      return {
        url: 'data-original',
        ...this.viewerOptions
      };
    }
  },
  methods: {
    // 补全供应商商品图片 yms-supplier-service 路径前缀
    formatSupplierProductImagePath(path) {
      if (!path) return '';
      if (/^https?:\/\//.test(path)) return path;
      if (path.includes('yms-supplier-service')) return path;
      const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
      return `/yms-supplier-service/${normalizedPath}`;
    },
    // 日志轮播图 70x70 缩略图地址
    getLogCarouselThumbUrl(path) {
      const imagePath = this.formatSupplierProductImagePath(path);
      if (!imagePath) return '';
      const fullPath = getFullImagePath(imagePath, null, true);
      return this.getThumbnailImage(fullPath, '/thumb/', '70x70', true);
    },
    // 日志轮播图原图预览地址
    getLogCarouselOriginalUrl(path) {
      const imagePath = this.formatSupplierProductImagePath(path);
      if (!imagePath) return '';
      return getFullImagePath(imagePath, null, true);
    },
    // 初始化操作日志弹窗，重置分页并加载日志数据
    async initProductReviewForSaleLogData(row) {
      this.productId = row.supplierProductId;
      this.curPage = 1;
      this.pageParams.pageNum = 1;
      this.collapseValue = [];
      this.userInfoList = await getAllUsersInfo();
      await this.getProductReviewForSaleLogData();
      this.productReviewForSaleLogModal = true;
    },
    // 分页获取商品操作日志列表数据
    async getProductReviewForSaleLogData() {
      if (!this.productId) {
        return;
      }
      let query = Object.assign({}, this.pageParams, {productId: this.productId});
      this.tableLoading = true;
      try {
        let res = await this.axios.post(api.post_productGoodsOperationLog_query, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000103')});
        this.tableLoading = false;
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            const list = data.list || [];
            this.logList = await Promise.all(
              list.map(async (item) => {
                if (isJSON(item.operateContent)) {
                  console.log('=========operateContent=========', JSON.parse(item.operateContent));
                }
                const result = await formatProductDetailsLog(item.operateContent, this.axios, item.operationType);
                return {
                  ...item,
                  logFormatSuccess: result.success,
                  formattedLogItems: result.items || []
                };
              })
            );
            this.total = data.total || 0;
            this.updateCollapseValue();
          } else {
            this.logList = [];
            this.total = 0;
            this.collapseValue = [];
          }
        }
      } catch (e) {
        this.tableLoading = false;
        this.logList = [];
        this.total = 0;
        this.collapseValue = [];
      }
    },
    // 获取 Collapse Panel 的唯一标识 name
    getPanelName(item, index) {
      return item.productGoodsId ? String(item.productGoodsId) + '_' + index : `${this.pageParams.pageNum}_${index}`;
    },
    // 根据操作人 ID 获取操作人名称
    getOperatorName(item) {
      if (this.userInfoList !== null && this.userInfoList[item.updatedBy] !== undefined) {
        return this.userInfoList[item.updatedBy].userName;
      }
      return this.systemTalg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000647') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000648');
    },
    // 格式化操作时间为完整日期时间
    formatLogTime(time) {
      return this.$uDate.dealTime(time, 'fulltime');
    },
    // 更新 Collapse 默认展开项，默认展开当前页前 20 条
    updateCollapseValue() {
      this.collapseValue = this.logList
        .slice(0, 20)
        .map((item, index) => this.getPanelName(item, index));
    },
    // 监听弹窗关闭，重置列表、分页及展开状态
    productReviewForSaleLogChange(value) {
      if (!value) {
        this.total = 0;
        this.curPage = 1;
        this.pageParams.pageNum = 1;
        this.logList = [];
        this.collapseValue = [];
        this.productId = null;
      }
    }
  },
  watch: {
    // 监听分页参数变化，重新获取日志数据
    pageParamsStatus(value) {
      if (value) {
        this.getProductReviewForSaleLogData();
        this.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.log_modal_content {
  display: flex;
  flex-direction: column;
}

.log_collapse_box {
  position: relative;
  max-height: 550px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  /deep/ .ivu-collapse {
    border: none;
    background-color: transparent;

    .ivu-collapse-item {
      border: 1px solid #dcdee2;
      margin-bottom: 10px;
    }

    .ivu-collapse-header {
      display: flex;
      align-items: center;
      padding: 10px 14px;
      background-color: #f7f7f7;
      min-height: auto;
      line-height: initial;
    }
  }

  .log_panel_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 98%;
    cursor: default;
  }

  .log_panel_user {
    font-weight: bold;
    color: #333;
  }

  .log_panel_time {
    color: #666;
  }

  .log_panel_content {
    padding: 10px 16px;
    color: #333;
    line-height: 1.6;
    word-break: break-all;
  }

  .log_compare_box {
    width: 100%;
  }

  .log_compare_cols {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .log_compare_col {
    flex: 1;
    min-width: 0;
  }

  .log_compare_divider {
    width: 1px;
    align-self: stretch;
    background-color: #e8eaec;
    flex-shrink: 0;
  }

  .log_compare_title {
    margin: 0 0 10px;
    font-weight: bold;
    color: #333;
  }

  .log_compare_field {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    .field_label {
      color: #333;
    }

    .field_value {
      color: #515a6e;
    }

    .log_image_list {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin-top: 4px;
    }

    .log_image_item {
      width: 70px;
      height: 70px;
      object-fit: cover;
      border: 1px solid #e8eaec;
      border-radius: 2px;
      cursor: pointer;
      vertical-align: middle;
    }
  }

  .empty_tip {
    text-align: center;
    padding: 40px 0;
    color: #999;
  }
}

.log_page_box {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e8eaec;
}
</style>
